import { ButtonLink } from "@ui/ButtonLink";
import { Modal } from "@ui/molecules/Modal/Modal";
import { VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { signInUrl } from "~/modules/shared/utils/auth";
import { askPageVars } from "../pageVars";

type Props = {
	onClose: () => void;
};

export const SignupGate = (props: Props) => {
	const vars = askPageVars();

	return (
		<Modal
			open={() => true}
			onClose={props.onClose}
			title={`Keep asking ${vars.influencer_display_name}`}
		>
			<VStack spacing="large">
				<Text size="small" color="fg2">
					Sign up to save this thread and ask more questions.
				</Text>
				<ButtonLink
					href={signInUrl()}
					size="small"
					variant="primary"
					theme="mint-grad"
					fullWidth
				>
					Sign up free
				</ButtonLink>
				<ButtonLink
					href={signInUrl()}
					size="small"
					variant="tertiary"
					fullWidth
				>
					Log in
				</ButtonLink>
			</VStack>
		</Modal>
	);
};
